import actions from '@/core/store/item-ata/transferencia/historico/actions'
import state from '@/core/store/item-ata/transferencia/historico/state'
import mutations from '@/core/store/item-ata/transferencia/historico/mutations'

export default { actions, state, mutations }
